<template>
	<div>
		<div class="wrap-navigate">
			<div class="avatar-div">
				<div>
					<avtarInput
						:avatar="avatar"
						@change="getAvatarUser"
						@imageSavedGetNewImage="getUserProfile()"
						:type="'profileImage'"
						defaultImage="/images/avatar.png"
					></avtarInput>
				</div>
				<div class="name">{{ profileUser.display_name }}</div>
				<div class="wrap-tooltip mb-3">
					<div
						id="userProfile"
						class="edit-profile"
						v-bind:class="{ active: activeNavigation == 'Profile' }"
						v-b-tooltip.hover
						:title="$t('userDashboard.navigation.mobile.profile')"
						@click="clickNavigate('user-profile')"
					>
						<EditIcon />
					</div>
					<div
						id="userMessage"
						class="notification"
						v-bind:class="{ active: activeNavigation == 'UserMessage' }"
						v-b-tooltip.hover
						:title="$t('userDashboard.control.messages')"
						@click="clickNavigate('message')"
					>
						<MessageOutlineIcon />
						<div class="notification-number" v-if="unreadMessages">
							{{ unreadMessages ? unreadMessages : 0 }}
						</div>
					</div>
					<div
						id="logout"
						class="logout"
						v-b-tooltip.hover
						:title="$t('userDashboard.navigation.logout')"
						@click="userLogout"
					>
						<LogoutIcon />
					</div>
				</div>
				<div class="wrap-coins">
					<span class="mif-coins"></span>
					<span
						>{{ $t('KhaosodCoins.myThaiRaithCoins') }} :
						{{ profileUser.coin }}</span
					>
				</div>
			</div>
			<div class="navigate">
				<div
					@click="clickNavigate('user-dashboard')"
					id="userDashboard"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'UserMain' }"
				>
					<div class="menu-icon">
						<ViewDashboardIcon />
					</div>
					<div class="menu-item">
						{{ $t('userDashboard.navigation.controlPanel') }}
					</div>
				</div>
				<div
					@click="clickNavigate('user-manage')"
					id="userListing"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'UserManageListing' }"
				>
					<div class="menu-icon">
						<FormatListBulletedIcon />
					</div>
					<div class="menu-item">
						{{ $t('userDashboard.navigation.mylisting') }}
					</div>
				</div>
				<div
					@click="clickNavigate('user-payment')"
					class="navigate-item"
					id="userListing"
					v-bind:class="{ active: activeNavigation == 'UserPayment' }"
				>
					<div class="menu-icon">
						<CreditCardOutlineIcon />
					</div>
					<div class="menu-item">
						{{ $t('userDashboard.navigation.payment') }}
					</div>
				</div>
				<div
					@click="clickNavigate('coins')"
					class="navigate-item"
					id="khaosodCoins"
					v-bind:class="{ active: activeNavigation == 'UserKhaosodCoins' }"
				>
					<div class="menu-icon">
						<span class="mif-coins"></span>
					</div>
					<div class="menu-item">
						{{ $t('userDashboard.navigation.khaosodCoin') }}
					</div>
				</div>
				<div
					@click="clickNavigate('user-statistic')"
					id="statistics"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'UserStatistic' }"
				>
					<div class="menu-icon">
						<TrendingUpIcon />
					</div>
					<div class="menu-item">
						{{ $t('userDashboard.navigation.statistics') }}
					</div>
				</div>
				<div
					@click="clickNavigate('user-contact')"
					id="contactReport"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'UserContact' }"
				>
					<div class="menu-icon">
						<EmailIcon />
					</div>
					<div class="menu-item">
						{{ $t('userDashboard.navigation.contactAndReport') }}
					</div>
				</div>
				<div v-if="agencyData.status==3||agencyData.logo_url"
					@click="clickNavigate('user-manage-agents')"
					id="UserManageAgents"
					class="navigate-item"
					v-bind:class="{ active: activeNavigation == 'UserManageAgents' }"
				>
					<div class="menu-icon">
						<IconPlus />
					</div>
					<div class="menu-item">
						{{ $t('userDashboard.navigation.agents') }}
					</div>
				</div>
				<div v-if="agencyData.status!=3&&!agencyData.logo_url"
					v-b-modal.show-package-model
					id="agencyPackageMenu"
					class="navigate-item extra-button"
				>
					<div class="menu-icon" style="border-right:none;color:white;">
						<IconHandShakeOutline />
					</div>
					<div id="agencyPackageMenu" class="menu-item" style="color:white;">
						{{ $t('userDashboard.navigation.becomeAgency') }}
					</div>
				</div>
			</div>
		</div>
		<div v-if="!isMobile" style="position:relative;z-index: 9;">
			<div
				class="mt-19"
				style="
					position: fixed;
					right: 105px;
					bottom: 22px;
					height: 58px;
					box-shadow: 0 5px 4px 0 rgba(0,0,0,.26);
					border-radius: 40px;bottom:20px;color:white;"
			>
				<button
					id="addListing"
					type="button"
					class="btn btn-post btn-primary"
					@click="gotoAddListing()"
					style="
						box-shadow: rgba(0, 0, 0, 0.26) 0px 5px 4px 0px;
						border-radius: 40px;
						width: 160px;
						height: 58px;
						font-size: 22px;
						background: var(--projectPrimaryColor) !important;
						border-color: var(--projectPrimaryColor) !important;color:white;"
				>
					<svg
						focusable="false"
						viewBox="0 0 24 24"
						aria-hidden="true"
						role="presentation"
						class="icon-list-add"
						style="color:white;filter: invert(1);"
					>
						<path
							d="M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z"
						></path>
					</svg>
					{{$t('post')}}
				</button>
			</div>
		</div>
		<b-modal
			id="show-package-model"
			class="package-model m-4"
			size="lg"
			hide-footer
			hide-header
			ref="showgooglemap-model"
			centered 
			no-close-on-backdrop
			no-close-on-esc
		>
			<div class="details-div d-flex flex-column  justify-content-between align-items-center align-self-center m-5">
				<img src="@/assets/agencylogo.png" :alt="$t('altTag',{ affiliate: $root.affiliate })"/>
				<div class="w-75 d-flex flex-row  justify-content-center align-items-center align-self-center m-3 text-center">	
					{{$t('userDashboard.navigation.becomeAgencyDialogText1') }} <br/> {{$t('userDashboard.navigation.becomeAgencyDialogText2') }} <br/>
					{{$t('userDashboard.navigation.becomeAgencyDialogText3')}}
				</div>
				<div class="d-flex flex-row w-100 justify-content-center align-items-center align-self-center mt-3">
					<b-button  class="cancel-button w-25 mr-3" @click="$bvModal.hide('show-package-model')">{{$t('userDashboard.navigation.cancel') }}</b-button>
					<b-button id="agencyPaymentButton" class="success-button w-25" @click="goToPayment()">{{$t('userDashboard.navigation.gotopayment') }}</b-button>

				</div>
			</div>

		</b-modal>
	</div>
</template>
<script>
// Icons
//import PencilOutlinedIcon from "vue-material-design-icons/PencilOutline.vue";
import EditIcon from '@/components/icons/IconEdit/index';
import MessageOutlineIcon from 'vue-material-design-icons/MessageOutline.vue';
import LogoutIcon from '@/components/icons/IconLogout/index';
import ViewDashboardIcon from 'vue-material-design-icons/ViewDashboard.vue';
import FormatListBulletedIcon from 'vue-material-design-icons/FormatListBulleted.vue';
import CreditCardOutlineIcon from 'vue-material-design-icons/CreditCardOutline.vue';
import TrendingUpIcon from 'vue-material-design-icons/TrendingUp.vue';
import EmailIcon from 'vue-material-design-icons/EmailOutline.vue';
import IconPlus from '@/components/icons/IconPlus';
import IconHandShakeOutline from '@/components/icons/IconHandShakeOutline';

import { mapGetters, mapActions, mapMutations } from 'vuex';
import avtarInput from '@/components/newAvtarUploader';

export default {
	components: {
		//PencilOutlinedIcon,
		MessageOutlineIcon,
		LogoutIcon,
		ViewDashboardIcon,
		FormatListBulletedIcon,
		CreditCardOutlineIcon,
		TrendingUpIcon,
		EmailIcon,
		avtarInput,
		EditIcon,
		IconHandShakeOutline,
		IconPlus,
		IconHandShakeOutline
	},
	props: {
		activeNavigation: {
			type: String,
			default: 'UserMain'
		}
	},
	computed: {
		...mapGetters('AdminAgencyController', ['agencyData']),
		...mapGetters('UserDashboardController', ['dataUserDashboard']),
		...mapGetters('UserController', [ 'isMobile']),
		...mapGetters('ChatController', ['unreadMessages']),
	},
	mounted() {
		let _this=this;
		this.getAvatarUser();
	},
	data() {
		return {
			avatarNew: null,
			saving: false,
			saved: false,
			avatar: null,
			profileUser: localStorage.getItem('user_profile')
				? JSON.parse(localStorage.getItem('user_profile'))
				: null
		};
	},
	created(){
		this.GET_NUMBER_OF_UNREAD_MESSAGE({admin:false})
		this.VERIFY_USER_AGENCY().then(({data})=>{
			if(data.data.status!=3){
				
			}
		});
	},
	methods: {
		...mapActions('AdminAgencyController', ['VERIFY_USER_AGENCY']),
		...mapActions('UserController', ['USER_PROFILE']),
		...mapActions('ChatController', ['GET_NUMBER_OF_UNREAD_MESSAGE']),
		clickNavigate(page) {
			if (window.location.pathname != this.$i18nRoute({ name: page })) {
				this.$router.push(this.$i18nRoute({ name: page }));
			}
		},
		uploadImage() {
			this.saving = true;
			setTimeout(() => this.savedAvatar(), 1000);
		},
		savedAvatar() {
			this.saving = false;
			this.saved = true;
		},
		userLogout() {
			this.$root.signOut();
		},
		getUserProfile(){
			console.log("get User Profile")
			this.USER_PROFILE({
              userToken: this.$root.user.access_token,
            }).then((data)=>{
				this.getAvatarUser();
			})
		},
		getAvatarUser() {
			setTimeout(() => {
				if (localStorage && localStorage.getItem('user_profile')) {
					let avatar_url = JSON.parse(localStorage.getItem('user_profile'))
						.profile_image;
					if (avatar_url) {
						this.avatar = avatar_url;
						this.$forceUpdate();
					} else {
						this.avatar = null;
						this.$forceUpdate();
					}
				}
			}, 500);
		},
		gotoAddListing() {
			if (this.$root.isAuthenticated) {
				this.$router.push(this.$i18nRoute({ name: 'add-listing' }));
			} else {
				this.openThairathLogin();
			}
		},
		openThairathLogin() {
			this.$root.signIn('add-listing');
		},
		goToPayment(){
			console.log("package bought")
			this.VERIFY_USER_AGENCY().then((data)=>{
				console.log("data",data);
				this.$router.push({
					name: 'Payment',
					params: {
						id: this.agencyData.id
					}
				});
			})
		}
	}
};
</script>
<style lang="scss">
@import 'userDashboardNavigate.scss';
</style>
